import React from 'react';

export default function ImportantAnnouncementModal({ announcement, onClose }) {
  if (!announcement) {
    return null;
  }

  const handleClose = async () => {
    await onClose(announcement.id);
  };

  return (
    <div className="pfp-news-modal__backdrop">
      <div className={`pfp-news-modal pfp-news-modal--${announcement.type || 'info'}`}>
        <div className="pfp-news-modal__header">
          <h3>{announcement.title}</h3>
        </div>

        <div
          className="pfp-news-modal__body"
          dangerouslySetInnerHTML={{ __html: announcement.message }}
        />

        <div className="pfp-news-modal__actions">
          {announcement.cta_label && announcement.cta_url && (
            <a className="pfand-button pfand-button--secondary" href={announcement.cta_url}>
              {announcement.cta_label}
            </a>
          )}

          <button type="button" className="pfand-button" onClick={handleClose}>
            {announcement.requires_ack ? 'Verstanden' : 'Schließen'}
          </button>
        </div>
      </div>
    </div>
  );
}
